import { useEffect } from "react";

import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

import Tracker from "@openreplay/tracker";
import * as Sentry from "@sentry/react";

import { getTenantId } from "@/global/TenantGuard";
import { getAccessToken, jwtClaims } from "@/utils/auth";
import { isProduction, isStaging } from "@/utils/helpers";

const shouldTrack = isProduction() && !isStaging();

export const openReplayTracker = new Tracker({
  projectKey: "tSNsYUeVjTpLrI6LxhSj",
});

export function initTrackers(): void {
  if (!shouldTrack) {
    return;
  }

  Sentry.init({
    dsn: "https://d49c4e56e2774f218f1c12fc5c4edb28@o4505023884034048.ingest.sentry.io/4505023910772736",
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });

  openReplayTracker.start();
}

export function updateUserInformation(): void {
  if (!shouldTrack) {
    return;
  }

  const userId = `${getTenantId()}-${getUserIdFromJWT()}`;

  Sentry.setUser({ id: userId });
  openReplayTracker.setUserID(userId);
}

function getUserIdFromJWT(): string | number | null {
  const token = getAccessToken();

  if (!token) {
    return null;
  }

  try {
    return jwtClaims(token).user_id ?? null;
  } catch {
    return null;
  }
}
